'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e$1 from "../defs/Link.es.js";
const e = a.forwardRef((r, t) => /* @__PURE__ */ a.createElement(p, { ref: t, ...r, weights: e$1 }));
e.displayName = "LinkIcon";
const c = e;
export {
  c as Link,
  e as LinkIcon
};
